export default __webpack_public_path__ + "static/media/piast_obrany.fb56ac14.svg";